export default __webpack_public_path__ + "import_template.csv";